import { Box, Typography } from '@mui/material';
import { DARK } from 'constants/colors';
import {
  ActivityResponse,
  ClientResponse,
  EmployeeResponse,
  EmployeeTypeResponse,
  PlanningEntityType,
  SchedulingLabel
} from 'generated/index';
import { getEmployeeName, getViewContext } from '../../../utils';
import { ViewContext } from '../../../enums';

type SecondNameSectionProps = {
  planningEntityType: PlanningEntityType;
  schedulingLabel?: SchedulingLabel;
  activity?: ActivityResponse;
  employee?: EmployeeResponse;
  client?: ClientResponse;
  employeeType?: EmployeeTypeResponse;
  isAbsent?: boolean;
  linkedDutyCode?: string;
};

function getVVSecondName(
  planningEntityType: PlanningEntityType,
  employee?: EmployeeResponse,
  employeeType?: EmployeeTypeResponse,
  client?: ClientResponse,
  activity?: ActivityResponse
) {
  if (planningEntityType === 'CLIENT') {
    return employee?.nameInformal || employeeType?.name || '';
  }
  return employeeType?.name || (client ? activity?.name : '') || '';
}

function getProjectWorkPlaceSecondName(
  employee?: EmployeeResponse,
  linkedDutyCode?: string
) {
  return getViewContext() == ViewContext.Team
    ? employee
      ? getEmployeeName(employee) || ''
      : linkedDutyCode ?? ''
    : '';
}

const SecondNameSection = ({
  planningEntityType,
  schedulingLabel,
  client,
  employee,
  activity,
  employeeType,
  isAbsent,
  linkedDutyCode
}: SecondNameSectionProps) => {
  const isProjectOrWorkplace =
    schedulingLabel === 'WORKPLACE' || schedulingLabel === 'PROJECT';

  const secondName = isProjectOrWorkplace
    ? getProjectWorkPlaceSecondName(employee, linkedDutyCode)
    : getVVSecondName(
        planningEntityType,
        employee,
        employeeType,
        client,
        activity
      );

  return (
    <Box>
      <Typography
        variant="caption"
        fontFamily="SourceSans"
        fontWeight={300}
        fontSize={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          marginRight: '4px',
          textDecoration: isAbsent ? 'line-through' : 'none',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          lineHeight: 1,
          color: DARK,
          padding: '4px 0 4px 4px'
        }}
      >
        {secondName}
      </Typography>
    </Box>
  );
};

export default SecondNameSection;
